<template>
  <b-card
    no-body
    :class="{ open: visible }"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-header
      :class="{ collapsed: !visible }"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click="updateVisible(!visible)"
    >
      <!-- <slot name="header"> -->
      <div
        style="
          background-color: #048042;
          padding: 5px;
          padding-left: 7px;
          padding-right: 7px;
          border-radius: 3px;
        "
      >
        <feather-icon
          v-if="title_img === 'filter'"
          icon="FilterIcon"
          color="#fff"
          style="width: 35px; height: 25px"
        />
        <menu-icon
          v-else
          class="custom-class"
          style="width: 35px; height: 25px"
          color="#fff"
        ></menu-icon>
      </div>
      <h4 class="text-primary" style="font-size: 18px">{{ title }}</h4>

      <!-- </slot> -->
    </b-card-header>

    <b-collapse
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <b-card-body>
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCollapse } from "bootstrap-vue";
import { v4 as uuidv4 } from "uuid";
import { MenuIcon } from "vue-feather-icons";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
    MenuIcon,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title_img: {
      type: String,
      required: true,
    },
    title:{
      type: String,
      required: "",
    }
  },
  data() {
    return {
      visible: false,
      collapseItemID: "",
      openOnHover: this.$parent.hover,
    };
  },
  computed: {
    accordion() {
      return this.$parent.accordion
        ? `accordion-${this.$parent.collapseID}`
        : null;
    },
  },
  created() {
    this.collapseItemID = uuidv4();
    this.visible = this.isVisible;
  },
  watch: {
    visible(value) {
      this.reandered();
    },
  },
  methods: {
    updateVisible(val = true) {
      this.visible = val;
      this.$emit("visible", val);
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true);
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false);
    },
    reandered() {
      this.$router.afterEach(() => {
        this.visible = false;
      });
    },
  },
};
</script>
